import { trackingService } from "../../common/services/tracking.service";
import {
  attachCampaignDataObject,
  deleteCookie,
  getCookie,
  getCampaignParamsFromCookie,
  snakeToCamelCase,
  writeCookie,
} from "../../common/utils/attribution.util";
import {
  getPendingConversion,
  clearPendingConversion,
} from "../../common/utils/conversion.util";
import { getAllParamsFromURL } from "../../common/utils/url.util";

$(async () => {
  try {
    trackingService.init();

    // Generate persistent visitor ID on first visit
    if (!getCookie("ryb_visitor_id")) {
      const visitorId = typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
          });
      writeCookie("ryb_visitor_id", visitorId, 365);
    }

    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);

    // Conversion detection — user returning from Jackrabbit registration
    if (params.get("source") === "webreg") {
      await handleConversionReturn();
    }

    if (!params.size || (params.size === 1 && params.get("source") === "webreg")) {
      return;
    }
    const urlParams = getAllParamsFromURL();
    if (
      urlParams?.campaign_id ||
      urlParams?.campaignId ||
      urlParams?.campaign ||
      urlParams?.utmSource ||
      urlParams?.utmMedium ||
      urlParams?.utmContent ||
      urlParams?.fbclid ||
      urlParams?.gclid ||
      urlParams?.msclikid ||
      urlParams?.dclid ||
      urlParams?.fbp ||
      urlParams?.ga ||
      urlParams?.gcl_au ||
      urlParams?._ga ||
      urlParams?._gcl_au ||
      urlParams?.fbc ||
      urlParams?.medium ||
      urlParams?.mediumId ||
      urlParams?.utm_source ||
      urlParams?.utm_medium ||
      urlParams?.utm_campaign ||
      urlParams?.utm_keyword ||
      urlParams?.utm_matchtype ||
      urlParams?.ad_group_id ||
      urlParams?.ad_id ||
      urlParams?.utm_term ||
      urlParams?.utm_content ||
      urlParams?.adGroupId ||
      urlParams?.adId ||
      urlParams?.session_source ||
      urlParams?.sessionSource
    ) {
      writeCookie("campaignCookies", btoa(queryString), 7);

      // Append to multi-touch attribution history in localStorage
      try {
        const history = JSON.parse(
          localStorage.getItem("ryb_attribution_history") || "[]"
        );
        const touchParams: Record<string, string> = {};
        new URLSearchParams(queryString).forEach((v, k) => {
          touchParams[k] = v;
        });
        history.push({
          timestamp: new Date().toISOString(),
          url: window.location.href,
          params: touchParams,
        });
        // Keep only the most recent 50 touch points
        if (history.length > 50) {
          history.splice(0, history.length - 50);
        }
        localStorage.setItem(
          "ryb_attribution_history",
          JSON.stringify(history)
        );
      } catch (e) {
        console.error("Failed to save attribution history:", e);
      }
    }
  } catch (error) {
    trackingService.captureException(
      new Error(
        `${window.location.host} | Campaign cookie - error occured while saving the cookie, url: ${window.location.href}`
      ),
      {
        devMessage: "Campaign cookie error while saving the cookie",
        url: window.location.href,
      }
    );
    console.error("Error with campaign: ", error);
  }
});

async function handleConversionReturn(): Promise<void> {
  const pending = getPendingConversion();

  if (!pending) {
    trackingService.pushEvent("ryb_conversion_no_context", {
      return_url: window.location.href,
    });
    cleanReturnParam();
    return;
  }

  let submissionUpdated = true;
  if (pending.submissionId) {
    try {
      await $.ajax({
        url: `https://${window.location.host}/wp-json/ryb/v1/submissions/${pending.submissionId}?timestamp=${Date.now()}`,
        method: "PUT",
        contentType: "application/json",
        data: JSON.stringify({
          funnel_last_step: "enrollment_confirmed",
          funnel_completed: 1,
        }),
      });
    } catch (error) {
      submissionUpdated = false;
      console.error("Failed to update submission on conversion:", error);
    }
  }

  if (!submissionUpdated) {
    return;
  }

  trackingService.pushEvent("ryb_enrollment_confirmed", {
    class_name: pending.className,
    class_id: pending.classId,
    selection_type: pending.selectionType,
    funnel_type: pending.funnelType,
    submission_id: pending.submissionId || "",
    ghl_contact_id: pending.ghlContactId || "",
  });

  trackingService.pushEvent("sign_up", {
    method: "jackrabbit",
  });

  clearPendingConversion();
  cleanReturnParam();
}

function cleanReturnParam(): void {
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete("source");
    window.history.replaceState({}, "", url.toString());
  } catch {
    // ignore if history API fails
  }
}

export {
  attachCampaignDataObject,
  deleteCookie,
  getCookie,
  getCampaignParamsFromCookie,
  snakeToCamelCase,
  writeCookie,
};
